import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { FontWeight, FontStyle } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

export class SymbolMultiplyCounter extends PIXI.Text {

    public readonly DEFAULT_TEXT_STYLE:TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        fill: "#ffe8d9",
        fontSize: 48,
        lineJoin: "round",
        stroke: "#ff0000",
        strokeThickness: 6,
        dropShadowDistance: 2,
        fontFamily : "Helvetica",
        fontStyle : FontStyle.ITALIC,
        fontWeight : FontWeight.EXTRA_BOLD,
    };

    constructor(){
        super("")
        this.style.align = "center";
        this.style = this.DEFAULT_TEXT_STYLE;
        this.anchor.set(0.5, 0.5);
    }
}